import React, { useState, useEffect } from "react";
import Sidemenu from "../../components/sidemenu";
import SecondStep from "./secondStep";
import * as Styled from "./styled";
import { useNavigate } from "react-router-dom";
import { functionService } from "../../lib/functions";
import PdfView from "../../components/candidateAssessmentPdf";
import Header from "../../components/header";

const AiMachineInterview = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const getAiInterViewData = async () => {
        try {
            const {
                response: {
                    data: { data },
                },
            } = await functionService.get(
                "machineinterview/getAllMachineInterview"
            );
            setData(data);
            setLoading(false);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAiInterViewData();
    }, [open]);

    return (
        <div style={{ display: "flex" }}>
            <div style={{ zIndex: "100" }}>
                <Sidemenu />
            </div>

            <Styled.RightContainer>
                {loading ? (
                    <div />
                ) : (
                    <>
                        {data?.length === 0 ? (
                            <Styled.FirstStepWrapper>
                                <Header />
                                <p>AI Machine Interviews</p>
                                <Styled.AddNewContainer
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%",
                                        height: "600px",
                                    }}
                                >
                                    <Styled.FirstStep>
                                        <p>No assessment created</p>
                                        <button
                                            onClick={() =>
                                                navigate("/ai-interview-form")
                                            }
                                        >
                                            Add New
                                        </button>
                                    </Styled.FirstStep>
                                </Styled.AddNewContainer>
                                <Styled.FooterText>© 2023 Coffeee.io. All rights reserved</Styled.FooterText>
                            </Styled.FirstStepWrapper>
                        ) : (
                            <SecondStep
                                data={data}
                                open={open}
                                setOpen={setOpen}
                            />
                        )}
                    </>
                )}
            </Styled.RightContainer>
            {/* <Styled.RightContainer>
               {step===1&& <Styled.FirstStep>
                    <p>No assessment created</p>
                    <button>Add New</button>
                </Styled.FirstStep>}
                {step===2&&<SecondStep/>}
            </Styled.RightContainer> */}
        </div>
    );
};

export default AiMachineInterview;
